<template>
  <div class="content">
    <div class="pro-mobile">
      <menu-mobile />
    </div>
    <div class="back-row-frame">
      <div class="v-c-left">
        <div
          ref="bonus_type"
          class="mall-dropdown"
          :class="{ active: isActive }"
          @click.stop="toggleDropdown"
        >
          <button class="dropbtn">
            {{ $t('Bao.roulette_bonus') }}
            <i class="dropbtn-arr" />
          </button>
          <div class="dropdown-content">
            <a @click.prevent>{{ $t('Bao.roulette_bonus') }}</a>
          </div>
        </div>
      </div>
      <div class="v-c-right">
        <div class="exchange-amount-frame">
          <div class="token-name">
            <span>{{ $t("Bao.roulette_mainturnover") }}</span>
          </div>
          <div class="token-amount">
            <span>{{ mainTurnover | numberFormatThird }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="view-card mall-min-h">
      <div v-if="!allProd" class="history-list-content if-no-data">
        <div class="no-data">
          <i>
            <img :src="require(`@/assets/${$store.getters.currentTheme}/images/no-data.png`)" alt="">
          </i>
          <p>{{ $t('Bao.no_relevant_data_records') }}</p>
          <span>{{ $t('Bao.search_results_are_empty') }}</span>
        </div>
      </div>
      <div v-else class="view-card-body ticket-list">
        <div
          v-for="(type, key) in allProd"
          :key="key"
          class="ticket-frame"
          @click="showModel(type)"
        >
          <div class="tf-left">
            <div class="bonus-cube">
              <div class="amount">
                {{ type.receive_prize }}
              </div>
              <div class="unit">
                {{ $t('Bao.point_unit') }}
              </div>
            </div>
          </div>
          <div class="tf-right">
            <div class="title">
              {{ $t('Bao.point_prize') }} {{ type.receive_prize }}
            </div>
            <div class="describe">
              {{ $t("Bao.roulette_turnover") }} {{ type.amount }}
            </div>
            <div class="second-half">
              <div class="describe">
                <div class="des-start">
                  {{ $t("Bao.roulette_date") }}
                </div>
                <div class="des-end">
                  {{ formatDate(type.created_at) }}
                </div>
              </div>
              <div>
                <a v-if="isLocked(type.amount)" class="btn btn-exchange lock">
                  <img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon-lock.png`)" alt="">
                </a>
                <a v-else class="btn btn-exchange">
                  {{ $t("Bao.redeem") }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <confirm-purchase-modal :is-active="showModal" :selected-prod="selectedProd" @hideModel="hideModel" />
    </div>
  </div>
</template>

<script>
import { getAllProductInfo, purchaseProd } from '@/api/shop'
import { detectMob, refreshGold, showNotice } from '@/utils/tool'
import confirmPurchaseModal from '@/components/modal/confirmPurchaseModal'
import menuMobile from '@/components/shop/menuMobile'

export default {
  components: {
    confirmPurchaseModal,
    menuMobile
  },
  data() {
    return {
      allProd: [],
      showModal: false,
      selectedProd: {},
      isActive: false
    }
  },
  computed: {
    mainTurnover() {
      const main_turnover = this.$store.getters.mainTurnover
      return parseFloat(main_turnover)
    }
  },
  watch: {
    '$store.state.user.isConfirmPurchase': function(newVal) {
      if (newVal) {
        this.buyProd(this.selectedProd)
        this.$store.commit('SET_SHOP_PURCHASE', false)
      }
    }
  },
  created() {
    this.$store.commit('SET_SHOP_PURCHASE', false)
    this.getAllProductInfo()
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    handleClickOutside(event) {
      const bonus_type = this.$refs.bonus_type
      if (this.isActive && bonus_type && !bonus_type.contains(event.target)) {
        this.isActive = false
      }
    },
    toggleDropdown() {
      this.isActive = !this.isActive
    },
    getAllProductInfo() {
      getAllProductInfo().then((response) => {
        this.allProd = response.data.data.data.daily_lottery
        if (this.allProd && this.allProd.length > 0) {
          this.allProd = this.allProd.map(prod => ({
            ...prod,
            name: prod.receive_prize + this.$t('Bao.point_unit'),
            type: 3,
            type_name: this.$t('Bao.point_type_roulette'),
            availBuy: !this.isLocked(prod.amount)
          }))
            .sort((a, b) => b.receive_prize - a.receive_prize)
        }
      })
        .then(
          refreshGold()
        )
        .catch(error => {
          this.allProd = null
          showNotice(error.response.data.msg)
        })
    },
    isMobile() {
      return detectMob()
    },
    isLocked(amount) {
      if (this.$store.getters.token) {
        return parseFloat(amount) > parseFloat(this.$store.state.user.memberInfo.main_turnover)
      }
    },
    buyProd(prod) {
      purchaseProd({ id: prod.id, sub_id: prod.sub_id }).then((response) => {
        showNotice(this.$t('Bao.success1'))
        this.getAllProductInfo()
      }).catch(() => {
        showNotice(this.$t('Bao.roulette_turnover_lack'))
      })
    },
    formatDate(timestamp) {
      const date = new Date((timestamp + 73 * 3600) * 1000)
      // 有效時間,因為我們是＋8的時區～但日本是＋9, 得用created_at的時間＋73小時

      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0') // Months are 0-indexed
      const day = String(date.getDate()).padStart(2, '0')

      return `${year}-${month}-${day}`
    },
    showModel(prod) {
      this.selectedProd = prod
      this.showModal = true
    },
    hideModel() {
      this.showModal = false
    }
  }
}
</script>

<style scoped>

</style>
